// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","4403":"arabicStyle"}[chunkId] + "." + {"532":"2019b37f48704dd2adf0","4403":"fa8a168bb9231f3bf775"}[chunkId] + ".css";
};